export interface EnhancementSettings {
  scoreColumn: boolean;
  rowHighlighting: boolean;
  compactMode: boolean;
  minRoi: number;
  minPop: number;
}

export const DEFAULT_SETTINGS: EnhancementSettings = {
  scoreColumn: true,
  rowHighlighting: true,
  compactMode: false,
  minRoi: 100,
  minPop: 70,
};

export interface ParsedContractRow {
  element: HTMLTableRowElement;
  ticker: string;
  sector: string;
  strike: number;
  price: number;
  target: number;
  rubricBand: string;
  expiry: string;
  dte: number;
  mid: number;
  collateral: number;
  annRoi: number;
  pop: number;
  held: number;
}

export interface StockForgeApiConfig {
  /** Proxy base URL, e.g. https://api.yourdomain.com */
  baseUrl: string;
}
